import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const Card = ({ t, i }) => (
    <motion.figure
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
        data-testid={`testimonial-${i}`}
        className="bg-beige-50 rounded-2xl p-7 md:p-8 ring-1 ring-stone-200/70 flex flex-col h-full"
    >
        <div className="flex items-center gap-1 mb-5 text-gold">
            {Array.from({ length: 5 }).map((_, k) => (
                <Star key={k} size={14} fill="currentColor" strokeWidth={0} />
            ))}
        </div>
        <Quote size={26} strokeWidth={1.2} className="text-gold-deep mb-4" />
        <blockquote className="font-serif text-lg md:text-xl text-stone-900 leading-snug">
            "{t.quote}"
        </blockquote>
        <figcaption className="mt-7 pt-5 border-t border-stone-200/80">
            <div className="font-medium text-stone-900">{t.name}</div>
            <div className="text-sm text-stone-500 mt-0.5">{t.role}</div>
        </figcaption>
    </motion.figure>
);

export const Testimonials = () => {
    const { t } = useTranslation();
    const items = t("testimonials.items", { returnObjects: true }) || [];

    return (
        <section
            id="testemunhos"
            data-testid="testimonials-section"
            className="py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="text-center max-w-2xl mx-auto mb-16 md:mb-20">
                    <div className="flex items-center justify-center gap-3 mb-5">
                        <span className="gold-divider" />
                        <span className="text-xs uppercase tracking-[0.24em] text-stone-500">
                            {t("testimonials.eyebrow")}
                        </span>
                        <span className="gold-divider" />
                    </div>
                    <h2 className="font-serif text-4xl sm:text-5xl text-stone-900 tracking-tight leading-[1.05]">
                        {t("testimonials.title_1")}{" "}
                        <em className="italic text-gold-deep font-normal">{t("testimonials.title_em")}</em>
                        .
                    </h2>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                    {items.slice(0, 3).map((item, i) => (
                        <Card key={`t-${item.name}-${i}`} t={item} i={i} />
                    ))}
                </div>
                <div className="grid md:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6 lg:max-w-5xl lg:mx-auto">
                    {items.slice(3, 5).map((item, i) => (
                        <Card key={`t-${item.name}-${i + 3}`} t={item} i={i + 3} />
                    ))}
                </div>
            </div>
        </section>
    );
};
